<template>
  <q-page class="q-px-xl q-pb-lg bg-grey-1">
    <c-toast
      ref="toast"
      class="toast"
    />
    <div class="pt-6 w-full">
      <h1 class="c-text-h2 c-text-gray-400 mb-16">
        Ordenar Simulados
      </h1>
    </div>
    <div class="row col-12">
      <FilePicker
        class="col-5 ui-mb-6"
        label="CSV de ordenação"
        :info="{
          message: `
            Use <a target='_blank' href='https://docs.google.com/spreadsheets/d/1vGb9aGZtHZiWg4sfizfV4L7wtu2A57eiakj8w2piiDo/edit?usp=sharing'>essa planilha</a> como base
          `, icon: 'info',
          iconFilled: true
        }"
        @change="(file) => orderCSVFile = file"
      />
      <div class="col-1" />
      <div class="col-3">
        <c-button
          size="lg"
          :disabled="!orderCSVFile"
          @click="orderExamQuestions"
        >
          Ordenar
        </c-button>
      </div>
    </div>
    <p class="c-text-b2">
      <span class="c-text-b1">IMPORTANTE: </span>somente as 500 primeiras linhas do arquivo serão processadas.
    </p>
  </q-page>
</template>

<script>
import FilePicker from '@/components/FilePicker';
import {
  CButton,
} from '@estrategiahq/coruja-web-ui';

export default {
  name: 'OrderStudentExam',
  components: {
    FilePicker,
    CButton,
  },
  data: () => ({
    orderCSVFile: null,
  }),
  methods: {
    showToast(type, text) {
      this.$refs.toast._show({
        type,
        text,
        timeout: 3000,
        position: 'top',
        width: 900,
      });
    },
    async orderExamQuestions() {
      this.$g.loading.show();
      try {
        await this.$services.studentExamsRest.orderExamQuestions(
          this.orderCSVFile
        );
        this.showToast('success', 'Ordenação concluida com sucesso.');
      } catch (err) {
        this.showToast('error', 'Houve um erro na ordenação.');
      }
      this.$g.loading.hide();
    },
  },
};
</script>

<style>

</style>
